import { FormEvent, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { signup } from '../../api/admin';
import '../Login/AdminLoginScreen.scss';

function AdminSignupScreen() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);

    if (password !== passwordConfirm) {
      setError('비밀번호가 일치하지 않습니다.');
      return;
    }

    setLoading(true);
    try {
      const { isMasterAdmin } = await signup({ email, password });
      const message = isMasterAdmin
        ? '최종관리자로 등록되었습니다. 로그인해주세요.'
        : '가입 신청이 완료되었습니다. 최종관리자 승인 후 로그인할 수 있습니다.';
      alert(message);
      navigate('/admin/login', { replace: true });
    } catch (err: any) {
      setError(err.response?.data?.message || '가입에 실패했습니다.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="LoginScreen">
      <form className="LoginScreen-card" onSubmit={handleSubmit}>
        <h1>전체관리자 가입</h1>
        <label>
          아이디
          <input type="text" value={email} onChange={(e) => setEmail(e.target.value)} required autoFocus />
        </label>
        <label>
          비밀번호
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
        </label>
        <label>
          비밀번호 확인
          <input
            type="password"
            value={passwordConfirm}
            onChange={(e) => setPasswordConfirm(e.target.value)}
            required
          />
        </label>
        {error && <p className="LoginScreen-error">{error}</p>}
        <button type="submit" disabled={loading}>
          {loading ? '가입 중...' : '가입하기'}
        </button>
        <Link to="/admin/login" className="LoginScreen-link">
          이미 계정이 있으신가요? 로그인
        </Link>
      </form>
    </div>
  );
}

export default AdminSignupScreen;
